export default __webpack_public_path__ + "static/media/pic18.1fdd40a7.jpg";